import { UseDataQueryOptions } from '../../../hooks/useDataQuery/dataQuery.types';
import useDataQuery from '../../../hooks/useDataQuery/useDataQuery';
import useInfiniteDataQuery from '../../../hooks/useInfiniteDataQuery/useInfiniteDataQuery';
import { InfiniteDataQueryFnUtils } from '../../../hooks/useInfiniteDataQuery/utils/useInfiniteDataQueryFn.utils';
import { OmitPaginatedEndpointParams } from '../../types';
import { getBusinessPolicyKey, getFindAvailableVouchersKey } from './businessPolicies.keys';
import { findAvailableVouchers, getBusinessPolicy } from './businessPolicies.repository';
import {
  BusinessPolicyDTO,
  BusinessPolicyVoucherDTO,
  FindAvailableVouchersParams,
} from './businessPolicies.types';

const AVAILABLE_VOUCHERS_PAGE_SIZE = 20;

export const useGetBusinessPolicy = (
  id: string,
  options?: UseDataQueryOptions<BusinessPolicyDTO>,
) =>
  useDataQuery<BusinessPolicyDTO>(
    {
      queryKey: getBusinessPolicyKey(id),
      queryFn: async () => {
        const response = await getBusinessPolicy(id);

        if (!response.ok || !response.data) {
          throw response.originalError;
        }

        return response.data;
      },
    },
    options,
  );

export const useInfiniteAvailableVouchers = (
  params: OmitPaginatedEndpointParams<FindAvailableVouchersParams>,
  options?: { isEnabled?: boolean },
) =>
  useInfiniteDataQuery<BusinessPolicyVoucherDTO>({
    limit: AVAILABLE_VOUCHERS_PAGE_SIZE,
    maxPages: null,
    isEnabled: options?.isEnabled,
    queryKey: getFindAvailableVouchersKey(params),
    defaultOrderBy: {},
    queryFn: InfiniteDataQueryFnUtils.fetcherWithCountAndParams(findAvailableVouchers, params),
  });
